export default "__VITE_ASSET__CfvqD6_V__"